import moment from 'moment';
import loginModel from '../../../../models/login.model'
import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import projectModel from "../../../../models/custom-vision/custom-vision.projects.model";
import languageModel from '../../../../models/language.model';
import ViewBase from '../../../view-base.view';
import { messageComponent } from '../../../../components/message/message.component';
import paginationComponent from '../../../../components/pagination/pagination.component';
import SingleSelectCommonComponentView from '../../../../components/common/single-select-common-component.view'
import { formats } from '../../../../config/constants';

import { easepick, AmpPlugin, RangePlugin, LockPlugin } from '@easepick/bundle';

export default function CVTrainingSubmissionsListView() {
    ViewBase.call(this);

    const DATE_SEPARATOR = '   ~   ';
    let datePicker;

    let currentCountry;

    let inputDataModel = { searchStatus: '', fromDate: '', toDate: '', searchProjectId: 0, totalCount: 0, pageIndex: 1, pageSize: 10 };
    let dateDisplayModel = { fromDate: '', toDate: '' };

    let list = [];
    let projectsList = [];
    let searchProjectSelectedItem = {};
    let processedStatusesList = [];
    let processedStatusSelectedItem = {};
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let needReset = true;
    let fromInitDate;
    let toInitDate;

    let initDateRangePicker = () => {
        let dateRangePickerEl = document.getElementById('report--date-range');

        if (!dateRangePickerEl) {
            return
        }
        datePicker = new easepick.create({
            element: dateRangePickerEl,
            css: [
                'static/css/easepick.css',
                'static/css/easepick-custom.css',
            ],
            autoApply: false,
            zIndex: 1000,
            readonly: false,
            format: 'YYYY.MM.DD',
            firstDay: 0, // 0 - Sun, 1 - Mon, ...
            grid: 2,
            calendars: 2,
            locale: {
                apply: this.getText("LT00000200", "Apply"),
                cancel: this.getText("LT00000057", "Cancel")
            },
            AmpPlugin: {
                dropdown: {
                    minYear: moment().subtract(5, 'years').format('YYYY'),
                    maxYear: null,
                    years: true,
                    months: true
                },
                resetButton: true,
                darkMode: false
            },
            RangePlugin: {
                delimiter: DATE_SEPARATOR
            },
            LockPlugin: {
                minDate: moment(new Date()).subtract(5, 'years').startOf('year').format('YYYY-MM-DD'),
                maxDate: moment(new Date()).endOf('year').format('YYYY-MM-DD')
            },
            plugins: [
                AmpPlugin,
                RangePlugin,
                LockPlugin
            ],
            setup(datePicker) {
                datePicker.on('select', e => {
                    inputDataModel.fromDate = moment(e.detail.start).format(formats.apiDateFormat);
                    inputDataModel.toDate = moment(e.detail.end).format(formats.apiDateFormat);
                    
                    dateDisplayModel.fromDate = moment(e.detail.start).format(formats.dateFormat);
                    dateDisplayModel.toDate = moment(e.detail.end).format(formats.dateFormat);
                    _loadTrainingSubmissions();
                })
            },
        });
    }

    let _loadTrainingSubmissions = () => {
        this.showLoading();

        trainModel.getTrainingSubmissionsList(
            _trainingSubmissionsListSuccessCallBack,
            _trainingSubmissionsListErrorCallBack,
            inputDataModel
        );
    }

    let _loadProjects = () => {

        projectModel.getProjectsList(
            (result) => {
                let listOfProjects = result;

                if (listOfProjects.length == 0) {
                    projectsList = [];
                }

                projectsList = [];
                projectsList.push({ code: "0", name: this.getText("LT00000421", "All Projects") });
                for (var i = 0; i < listOfProjects.length; i++) {
                    projectsList.push({ code: listOfProjects[i].id.toString(), name: listOfProjects[i].name });
                }
                searchProjectSelectedItem = { code: "0", name: this.getText("LT00000421", "All Projects") };

            }, (error) => {

                if (error.code == 404) {
                    projectsList = [];
                }

                this.handleError(error);
            },
            false
        );
    }

    let _loadProcessedStatus = () => {
        processedStatusesList.push({ code: "", name: this.getText("LT00000143", "All") });
        processedStatusesList.push({ code: "001", name: this.getText("LT00000422", "Pending Approval") });
        processedStatusesList.push({ code: "002", name: this.getText("LT00000423", "Approved") });
        processedStatusesList.push({ code: "003", name: this.getText("LT00000424", "Rejected") });
        processedStatusesList.push({ code: "004", name: this.getText("LT00000425", "Cancelled") });

        processedStatusSelectedItem = { code: "", name: this.getText("LT00000143", "All") };
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadTrainingSubmissions();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadTrainingSubmissions();
    }

    let _trainingSubmissionsListSuccessCallBack = (result) => {
        this.hideLoading();

        list = result.data;
        if (list == null) {
            list = [];
        }
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
    }

    let _trainingSubmissionsListErrorCallBack = (error) => {
        this.hideLoading();

        list = [];

        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    let _search = () => {
        inputDataModel.pageIndex = 1;
        _loadTrainingSubmissions();
    }

    let _clearFilter = () => {
        inputDataModel.searchProjectId = 0;
        _initControls();
    }

    // let _onDatePickerChange = (start, end) => {
    //     inputDataModel.fromDate = start;
    //     inputDataModel.toDate = end;
    // }

    let _initControls = () => {
        fromInitDate = moment(new Date()).subtract(1, 'month');
        toInitDate = moment(new Date());
        inputDataModel.fromDate = fromInitDate.format(formats.apiDateFormat);
        inputDataModel.toDate = toInitDate.format(formats.apiDateFormat);
        inputDataModel.searchProjectId = 0;
        searchProjectSelectedItem = { code: "0", name: this.getText("LT00000421", "All Projects") };
        inputDataModel.searchStatus = '';
        processedStatusSelectedItem = { code: "", name: this.getText("LT00000143", "All") };
        needReset = !needReset;
                    
        dateDisplayModel.fromDate = fromInitDate.format(formats.dateFormat);
        dateDisplayModel.toDate = toInitDate.format(formats.dateFormat);
    }

    let _showCancelTrainingConfirmation = (trainingRequestId) => {
        this.showConfirm(this.getText("LT00000140XX", "Are you sure you want to cancel this training request?"), this.getText("LT00000426", "Cancel Request"), (e) => {

            if (e == "YES") {
                trainModel.cancelTrainingRequest(
                    () => {
                        this.showMessage(this.getText("LT00000142XX", "The training request has been cancelled."), this.getText("LT00000426", "Cancel Request"));

                        _loadTrainingSubmissions();
                    }, (error) => {
                        this.handleError(error);
                    },
                    trainingRequestId);
            }
        });

    }

    return {
        oninit: (vnode) => {
            _initControls();
            currentCountry = loginModel.credentials.country;

            _loadProcessedStatus();
            _loadProjects();
            _loadTrainingSubmissions();
        },
        oncreate: (vnode) => {
            initDateRangePicker();
        },
        onupdate: (vnode) => {
            if (loginModel.credentials.country !== currentCountry) {
                _loadProjects();
                _loadTrainingSubmissions();
                currentCountry = loginModel.credentials.country;
            }
        },    
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.d-flex.justify-content-end.mb-2',
                            m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]',
                                m('span.search-arrow.me-2',
                                    m('i.bi.bi-search')
                                ), this.getText("LT00000001", "Search")
                            )
                        ),
                        m('.searchbox.collapse[id="showSearchBarRc"]',
                            m('.card.mb-3',
                                m('.card-body.py-3',
                                    m('.row',
                                        m('.container',
                                            m('.row',
                                                m('.col-md-3',
                                                    m('label.form-label', this.getText("LT00000070", "Date Range")),
                                                    m('.easepick-input-group',
                                                        m('input#report--date-range.form-control', {
                                                            value: dateDisplayModel.fromDate + DATE_SEPARATOR + dateDisplayModel.toDate
                                                        }),
                                                        m('i.bi.bi-calendar-range-fill')
                                                    )
                                                ),
                                                m('.col-md-3',
                                                    m('label.form-label', this.getText("LT00000015", "Projects")),
                                                    m(SingleSelectCommonComponentView, {
                                                        iconList: [],
                                                        selectedItem: searchProjectSelectedItem,
                                                        handleSelect: (item) => { inputDataModel.searchProjectId = parseInt(item["code"]); searchProjectSelectedItem = item; },
                                                        items: projectsList,
                                                    })
                                                ),
                                                m('.col-md-3',
                                                    m('label.form-label', this.getText("LT00000039XX", "Status")),
                                                    m(SingleSelectCommonComponentView, {
                                                        iconList: [],
                                                        selectedItem: processedStatusSelectedItem,
                                                        handleSelect: (item) => { inputDataModel.searchStatus = item["code"]; processedStatusSelectedItem = item; },
                                                        items: processedStatusesList,
                                                    })
                                                ),
                                                m('.col-md-3.gap-2.d-sm-flex.mt-4',
                                                    m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, languageModel.getText("LT00000001", "Search")),
                                                    m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                                                ),
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        m('.card',
                            m('.card-body',
                                m(".table-responsive",
                                    m("table.table table-striped",
                                        [
                                            m("thead",
                                                m("tr.align-middle",
                                                    [
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000134XX", "S/N")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000134XX", "Project")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000012XX", "Submitted At")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000012XX", "Processed At")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000012XX", "Result")),
                                                        m("th", { "scope": "col" }, '')
                                                    ])
                                            ),
                                            m("tbody",
                                                list.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": "6" }, languageModel.getText("EM00000141", "No records found."))
                                                ),
                                                list.length > 0 && list.map((trainingRequest, index) =>
                                                    [
                                                        m("tr",
                                                            [
                                                                m("td", index + 1),
                                                                m("td", trainingRequest.projectName),
                                                                m("td", trainingRequest.createDateDisplay),
                                                                trainingRequest.status == '001' && m("td", ''),
                                                                trainingRequest.status == '001' && m("td", m('span.text-warning', 'Pending Approval')),
                                                                trainingRequest.status != '001' && m("td", trainingRequest.processedDateDisplay),
                                                                trainingRequest.status != '001' && m("td",
                                                                    trainingRequest.status == '002' ?
                                                                        'Approved' :
                                                                        (trainingRequest.status == '004' ?
                                                                            'Cancelled' :
                                                                            m('span.text-danger', 'Rejected: ' + trainingRequest.reason))),
                                                                trainingRequest.status == '001' && m("td", m("a", { "href": "javascript:;", onclick: () => { _showCancelTrainingConfirmation(trainingRequest.id) }, "class": "text-danger" }, [m("i", { "class": "bi bi-trash" }), m("span", this.getText("LT00000057XX", "Cancel Request"))])),
                                                                trainingRequest.status != '001' && m("td", ''),
                                                            ])
                                                    ]),
                                            )
                                        ]
                                    )
                                ),
                                m(paginationComponent,
                                    {
                                        currentPage: inputDataModel.pageIndex,
                                        pageSize: inputDataModel.pageSize,
                                        totalItems: inputDataModel.totalCount,
                                        onPageChanged: onPageChanged,
                                        onPageSizeChanged: onPageSizeChanged
                                    }
                                )
                            )
                        )
                    ),
                    m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
                ),
                this.getBaseViews()
            ]
        }
    }
}
